import { BRAND } from "constants/brand";
/**
 * Label row for a multi-select field with "select all" / "clear" shortcuts.
 * Used by the delivery offer Add/Edit modals so the admin can apply an offer
 * to every restaurant or area in the city without clicking them one by one.
 *
 * "Select all" is a snapshot of the currently available options — restaurants
 * or areas added later are not pulled in automatically.
 */
const linkButtonStyle = {
    background: "none",
    border: "none",
    padding: 0,
    cursor: "pointer",
    fontSize: "0.8rem",
    color: BRAND,
};

const SelectFieldHeader = ({ label, required, options, selected, onSelectAll, onClear }) => (
    <div
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "4px",
        }}
    >
        <span className="form-label" style={{ marginBottom: 0 }}>
            {label}
            {required ? <span style={{ color: "red" }}>*</span> : null}
        </span>
        <div style={{ display: "flex", gap: "12px" }}>
            <button
                type="button"
                style={{ ...linkButtonStyle, opacity: options.length ? 1 : 0.5 }}
                onClick={() => onSelectAll(options)}
                disabled={options.length === 0}
            >
                اختر الكل ({options.length})
            </button>
            <button
                type="button"
                style={{ ...linkButtonStyle, opacity: selected.length ? 1 : 0.5 }}
                onClick={onClear}
                disabled={selected.length === 0}
            >
                مسح
            </button>
        </div>
    </div>
);

export default SelectFieldHeader;
